import { Component, OnInit, Signal, WritableSignal, computed, signal, inject } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, map, tap } from 'rxjs';
import { WeatherSupportService } from '../../services/weather-support.service';
import { IWeatherObservation, WeatherService } from '../../services/weather.service';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { NgClass } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-application-toolbar-content-icon-gale-warning',
    imports: [
        NgClass,
        MatButtonModule,
        MatIconModule,
        MatBadgeModule,
    ],
    templateUrl: './application-toolbar-content-icon-gale-warning.component.html',
    styleUrl: './application-toolbar-content-icon-gale-warning.component.scss'
})
export class ApplicationToolbarContentIconGaleWarningComponent implements OnInit {
  readonly weatherService = inject(WeatherService);
  readonly weatherSupportService = inject(WeatherSupportService);
  readonly dialogService = inject(MatDialog);
  readonly router = inject(Router);

  public readonly galeWarningThresholdKt = 28;
  public readonly galeWarningThresholdStormKt = 34;
  public currentMaxWindKtS: WritableSignal<number> = signal(0);
  public currentMaxWindBftS: Signal<number> = computed(() => this.weatherSupportService.windSpeedKtToBeaufort(this.currentMaxWindKtS()));
  public currentWindTermS: Signal<string> = computed(() => this.weatherSupportService.windSpeedKtToWindTerm(this.currentMaxWindKtS(), 'de'));
  public windDirectionFromS: WritableSignal<string> = signal('');
  public galeWarningIconS: Signal<string> = computed(() => this.currentMaxWindKtS() >= this.galeWarningThresholdStormKt ? 'wi-gale-warning' : 'wi-small-craft-advisory');

  /**
   * Lifecycle hook to initialize the component
   */
  ngOnInit() {
    /**
     * Subscribe to the weather observation and filter out the undefined values
     * Map the observation to the max wind speed or gusts and set the current max wind speed
     */
    this.weatherService.observation$.pipe(
      untilDestroyed(this),
      filter((observation: IWeatherObservation | undefined) => !!observation),
      map((observation: IWeatherObservation) => ({
        maxWindKt: (observation.windGustKt && observation.windGustKt > observation.windSpeedKt) ? observation.windGustKt : observation.windSpeedKt,
        windDirectionFrom: this.weatherSupportService.windAngleToWindDirection(observation.windDirection || 0)
      })),
      tap(res => {
        this.currentMaxWindKtS.set(res.maxWindKt);
        this.windDirectionFromS.set(res.windDirectionFrom);
      }),
    ).subscribe();
  }

  /**
   * Method to present gale warning
   */
  presentGaleWarning() {
    this.dialogService.open(InfoDialogComponent, {
      data: {
        title: 'Wind-Warnung',
        infoText: `Aktuell herrscht ${this.currentWindTermS()} im YSTM.`,
        additionalText: `Wind mit ${this.currentMaxWindKtS()} kn (${this.currentMaxWindBftS()} Beaufort) aus ${this.windDirectionFromS()}.`, btnText: 'Wetter'
      }
    }).afterClosed().pipe(
      untilDestroyed(this),
      tap(async () => await this.router.navigate(['wetter']))
    ).subscribe();
  }

}
